import React, { FunctionComponent, Fragment } from "react"
import {
  Theme,
  makeStyles,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
  Divider,
  Grid,
} from "@material-ui/core"
import { Clear, Domain } from "@material-ui/icons"
import { HousingManagement } from "../../../../api/graphql/query/housing-managements"

const useStyles = makeStyles((theme: Theme) => ({
  clearButton: {
    cursor: "pointer",
    color: theme.palette.secondary.dark,
  },
  listItem: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    alignItems: "flex-start",
  },
}))

interface IHousingManagementListitemProps {
  housingManagement: HousingManagement
  onRemove: (housingManagement: HousingManagement) => void
}

export const HousingManagementListitem: FunctionComponent<IHousingManagementListitemProps> = (props) => {
  const classes = useStyles()
  const { housingManagement, onRemove } = props
  return (
    <Fragment>
      <ListItem className={classes.listItem}>
        <ListItemAvatar>
          <Avatar>
            <Domain />
          </Avatar>
        </ListItemAvatar>
        <ListItemText>
          <Grid container direction="row">
            <Grid item xs>
              <Typography>{housingManagement.name}</Typography>
            </Grid>
            <Grid item>
              <Grid container justify="flex-end">
                <Clear onClick={() => onRemove(housingManagement)} className={classes.clearButton} />
              </Grid>
            </Grid>
          </Grid>
        </ListItemText>
      </ListItem>
      <Divider component="li" />
    </Fragment>
  )
}
